module.exports = __webpack_public_path__ + "img/luthi-5.6999c008.jpg";